<div class="row">
    <div [ngClass]="isAssign ? 'col-sm-6' : 'col-sm-11'">
        <kendo-grid #tableGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [pageable]="true"
                    [sortable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-sml btn-secondary m-1" title="Assign" tabindex="-1" (click)="assign(dataItem.employeeRoleId)"><i class="fas fa-users"></i></button>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="employeeRoleId" title="ID"></kendo-grid-column>
            <kendo-grid-column field="name" title="Role Name"></kendo-grid-column>
        </kendo-grid>
    </div>

    <div class="col-sm-6" *ngIf="isAssign">
        <!-- Assign form -->
        <employee-role-group-assign [tableID]="tableID" (onRefresh)="cancelEdit()"></employee-role-group-assign>
    </div>
</div>
